import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { AVATAR_SIZE_52 } from '../../../../../../../constants/avatar-sizes';
import IdentityAvatarContainer from '../../../../../../../containers/global/identity/IdentityAvatarContainer';
import Badge from '../../../../../../../components/global/Badge';

const propTypes = {
  identity: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    last_name: PropTypes.string,
  }).isRequired,
  onClick: PropTypes.func,
  matchesCount: PropTypes.number,
  isActive: PropTypes.bool,
  className: PropTypes.string,
};

const defaultProps = {
  onSelect: () => {},
};

const IdentitySelectorAvatar = ({
  identity,
  onClick,
  matchesCount,
  isActive,
  className,
}) => {
  const classes = classNames({
    'identity-selector-avatar': true,
    'is-active': isActive,
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <IdentityAvatarContainer
        identity={identity}
        size={AVATAR_SIZE_52}
        className="identity-selector-avatar-photo"
        onClick={onClick}
        selected={isActive}
      />
      <Badge badgeSize="xs" round className="text-extra-bold">
        {matchesCount}
      </Badge>
    </div>
  );
};

IdentitySelectorAvatar.propTypes = propTypes;
IdentitySelectorAvatar.defaultProps = defaultProps;

export default IdentitySelectorAvatar;
